import first from "../../images/hotel/1.webp";
import second from "../../images/hotel/2.webp";
import third from "../../images/hotel/3.webp";
import fourth from "../../images/hotel/4.webp";

const sliderData = [first, second, third, fourth];
export default sliderData;
